import { gql } from "lib/apolloClient";
import { attachmentFragment } from "modules/CommonFragments";
import { questionFragments } from "Worksheet/modules/WorksheetFragments";

export const organizationResourceFragment = {
  organizationResource: gql`
    fragment organizationResourceItem on OrganizationResource {
      id
      label
      attachment {
        ...attachmentItem
      }
      policiesAndResourcesSharedGrades {
        id
        name
        curriculumProgram {
          id
          label
        }
      }
      childrenV2(orderBy: CREATED_AT, orderByDirection: ASC) {
        resourceTypeBasedCount {
          totalCount
        }
        edges {
          node {
            id
            item {
              ...questionDetailsItem
            }
            childrenV2(orderBy: CREATED_AT, orderByDirection: ASC) {
              resourceTypeBasedCount {
                totalCount
              }
              edges {
                node {
                  id
                  item {
                    ...questionDetailsItem
                  }
                }
              }
            }
          }
        }
      }
      isImported: isImportedFromDiffOrg
      isDeleted
      type
      resourceType
      visibleTo
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
      }
      state
      policiesAndResourcesSharedGrades {
        id
        name
        curriculumProgram {
          id
          label
        }
      }
      item {
        ... on OrganizationResource {
          id
          label
          isImported: isImportedFromDiffOrg
          attachment {
            ...attachmentItem
          }
          isDeleted
          type
          resourceType
          visibleTo
        }
      }
      tags {
        id
        key
        value
      }
      parentCurriculumProgram {
        id
        label
        type
      }
    }
    ${attachmentFragment.attachment}
    ${questionFragments.questionDetails}
  `,
  basicDetails: gql`
    fragment organizationResourceBasicDetailsItem on OrganizationResource {
      id
      label
      attachment {
        ...attachmentItem
      }
    }
    ${attachmentFragment.attachment}
  `,
};

export const organizationChildResourceFragment = {
  childResourceFragment: gql`
    fragment organizationChildResourceItem on OrganizationResource {
      id
      label
      children(
        visibleTo: $visibleTo
        searchText: $searchText
        orderBy: $orderBy
        orderByDirection: $orderByDirection
        filters: $filters
      ) {
        ...organizationResourceItem
      }
      isDeleted
      visibleTo
      resourceType
      parentHierarchy {
        id
        label
      }
      tags {
        key
        id
        value
      }
    }
    ${organizationResourceFragment.organizationResource}
  `,
  childResourceFragmentV2: gql`
    fragment organizationChildResourceItemV2 on OrganizationResource {
      id
      label
      children: childrenV2(
        first: $first
        after: $after
        orderBy: $orderBy
        orderByDirection: $orderByDirection
        filters: $filters
      ) {
        resourceTypeBasedCount {
          folderCount
          fileCount
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...organizationResourceItem
          }
        }
      }
      isDeleted
      visibleTo
      resourceType
      parentHierarchy {
        id
        label
      }
      tags {
        key
        id
        value
      }
    }
    ${organizationResourceFragment.organizationResource}
  `,
};
